import React, { useImperativeHandle } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { Grid } from '@material-ui/core'
import PropTypes from 'prop-types'
import SydLabel from '../../../../commonDesign/SydLabel'
import SydSelect from '../../../../commonDesign/SydSelect'

const AssignmentForm = React.forwardRef(function AssignmentForm ({ statusTemplateOptions, client, assignments, disabled }, ref) {
  const form = useForm({
    defaultValues: {
      clientId: client.clientId,
      statusTemplateIds: assignments?.statusTemplateIds
    }
  })

  useImperativeHandle(ref, () => ({ form }), [form])

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={6}>
        <Controller
          name='statusTemplateIds'
          control={form.control}
          render={(f) => (
            <SydLabel label='Status Template'>
              <SydSelect
                disabled={disabled}
                options={statusTemplateOptions}
                fullWidth
                multiple
                size='sm'
                {...f.field}
              />
            </SydLabel>
          )}
        />
      </Grid>
    </Grid>
  )
})

AssignmentForm.propTypes = {
  statusTemplateOptions: PropTypes.array,
  client: PropTypes.object,
  assignments: PropTypes.array,
  disabled: PropTypes.bool
}

export default AssignmentForm
